import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ChoiceGroup as CChoiceGroup, ChoiceGroupPropOnChange } from '@consta/uikit/ChoiceGroup';

export const ChoiceGroup = ({
  items,
  value,
  onChange,
  className = '',
}: {
  items: Choice[];
  value: Choice;
  onChange?: (item: Choice) => void;
  className?: string;
}) => {
  const [_value, setValue] = useState<Choice | null>(value ?? items[0]);

  useEffect(() => setValue(value), [value]);

  const onItemChange: ChoiceGroupPropOnChange<Choice, false> = ({ value }) => {
    setValue(value);
    typeof onChange === 'function' && onChange(value);
  };

  return (
    <CChoiceGroup
      className={classNames(className)}
      value={_value}
      onChange={onItemChange}
      items={items}
      getItemLabel={(item) => item.label}
      multiple={false}
      name="ChoiceGroup"
    />
  );
};

export type Choice = {
  value: string;
  label: string;
};
